import { Card, CardContent } from '@/components/ui/card';
import StatusPill from './StatusPill';
import { toneFor } from './tone';

interface DataQualityCardProps {
  item: Record<string, unknown>;
}

export default function DataQualityCard({ item }: DataQualityCardProps) {
  // Normalize: API may return {source, severity, metric, delta_pct} or mock {platform, status, issue}
  const platform = String(item.platform || item.source || item.channel || 'Unknown');
  const status = String(item.status || (
    item.severity === 'critical' ? 'poor' :
    item.severity === 'warning' ? 'partial' : 'good'
  ));
  const issue = String(
    item.issue ||
    item.message ||
    (item.metric ? `${item.metric}: ${item.delta_pct ? `${item.delta_pct}% discrepancy` : 'flagged'}` : '') ||
    'No issues detected'
  );

  const statusLabel = status === 'good' ? 'Good' : status === 'partial' ? 'Partial' : 'Poor';

  return (
    <Card size="sm">
      <CardContent className="px-4.5 py-1">
        <div className="mb-2 flex items-center justify-between gap-2.5">
          <div className="flex items-center gap-2 text-sm font-semibold tracking-[-0.01em] text-foreground">
            <img
              src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(platform.toLowerCase().replace(/\s+\/?\s*/g, '').replace(/[^a-z0-9]/g, ''))}.com&sz=32`}
              alt=""
              className="size-4 shrink-0 rounded-sm object-contain"
              onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
            />
            {platform}
          </div>
          <StatusPill tone={toneFor(status)}>{statusLabel}</StatusPill>
        </div>
        <p className="text-[12.5px] leading-relaxed text-muted-foreground text-pretty">{issue}</p>
      </CardContent>
    </Card>
  );
}
